export default __webpack_public_path__ + "static/icon1-d4e11093153191c3d6e017790e19e658.png";